

























  import { defineComponent, ref, onMounted } from 'vue'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  export default defineComponent({
    name: 'OneShopForm',
    components: { OneTaskForm: () => import('~/components/molecules/forms/OneTaskForm.vue') },
    props: {
      categoryId: {
        type: Number,
        default: null,
      },
      alt: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: 'one-shop-form',
      },
    },
    setup(props: { categoryId: number; id: string }) {
      const vm = useCurrentInstance()
      const isLoaded = ref(false)
      const isSubmitted = ref(false)
      const isFormNotAvailable = ref(false)
      const shopForm = ref({})
      const shopFormRef = ref()
      const initialFormData = ref({})
      const getAdditionalFields = async () => {
        return await vm.$api.tasks.app
          .getFormByCategoryId(props.categoryId)
          .then(({ data }: any) => {
            shopForm.value = data.schema
            initialFormData.value = JSON.parse(JSON.stringify(data.schema))
          })
          .catch((err: any) => {
            isFormNotAvailable.value = true
          })
          .finally(() => {
            isLoaded.value = true
          })
      }

      const submitForm = async () => {
        const isValid = await shopFormRef.value.validate()
        if (!isValid) return
        let token = ''
        if (vm.$recaptcha) {
          try {
            token = await vm.$recaptcha('shopForm')
            if (!token) return
          } catch (error) {
            console.log('Recaptcha error:', error)
            return
          }
        }

        vm.$api.tasks.app
          .submitForm(
            {
              categoryId: props.categoryId,
              content: shopForm.value as any,
            },
            token,
          )
          .then(() => {
            isSubmitted.value = true
            vm.$notify({
              group: 'alert',
              type: 'success',
              text: vm.$t('form.msg.sent') as string,
            })
          })
          .catch(() => {
            vm.$notify({
              group: 'alert',
              type: 'error',
              text: vm.$t('backend_errors.default') as string,
            })
          })
      }

      const resetForm = () => {
        shopForm.value = JSON.parse(JSON.stringify(initialFormData.value))
        isSubmitted.value = false
        if (shopFormRef.value?.reset) {
          shopFormRef.value.reset()
        }
      }

      getAdditionalFields()

      onMounted(async () => {
        try {
          if(vm.$recaptchaLoaded) {
            await vm.$recaptchaLoaded()
          }
        } catch (e) {
          console.log(e)
        }
      })

      return {
        shopForm,
        shopFormRef,
        isLoaded,
        isSubmitted,
        isFormNotAvailable,
        getAdditionalFields,
        submitForm,
        resetForm,
      }
    },
  })
